import React from 'react';
import { createRoot } from 'react-dom/client';
import App from '../App';

// Catch errors and display them visibly instead of a blank white screen
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return React.createElement('div', {
        style: {
          padding: '24px', fontFamily: 'monospace',
          background: '#fff3f3', border: '2px solid #e00',
          margin: '24px', borderRadius: '8px',
        },
      },
        React.createElement('h2', { style: { color: '#c00' } }, '⚠️ Render Error'),
        React.createElement('pre', { style: { whiteSpace: 'pre-wrap', fontSize: '13px' } },
          this.state.error?.toString() + '\n\n' + this.state.error?.stack
        )
      );
    }
    return this.props.children;
  }
}

function AppWithBoundary() {
  return React.createElement(ErrorBoundary, null, React.createElement(App));
}

// Use createRoot directly to avoid react-native-web's renderLegacy path
// which calls ReactDOM.render() — removed in React 19
const container = document.getElementById('root');
const root = createRoot(container);
root.render(React.createElement(AppWithBoundary));
